import { render } from "./Faq.vue?vue&type=template&id=75429b7c"
import script from "./Faq.vue?vue&type=script&lang=ts"
export * from "./Faq.vue?vue&type=script&lang=ts"
script.render = render

export default script